import { tns } from 'tiny-slider/src/tiny-slider';

export function StoriesModal() {
	StoriesModalInit();
}

let $ = window.jQuery;

// Story Modal for Homepage
let slider = null;
let storyModal = $( '.bsd-stories-modal' );
let storyModalTrigger = $( '.bsd-story-modal-trigger' );

// @since 2.2 Scroll to modal after opening
function StoriesModalInit() {

	if ( !$( '.bsd-js-stories-details' ).length ) return;

	slider = tns( {
		container: '.bsd-js-stories-details',
		items: 1,
		slideBy: 'page',
		autoplay: false,
		nav: false,
		prevButton: '.bsd-stories-modal-footer .pagination__btn--prev',
		nextButton: '.bsd-stories-modal-footer .pagination__btn--next',
		autoHeight: true,
		mode: 'gallery',
		loop: false
	} );

	// Open Modal
	storyModalTrigger.each( function ( i ) {
		$( this ).on( 'click', function ( e ) {
			e.preventDefault();
			let linkTarget = e.target.getAttribute( 'href' );

			// If link target exists, scroll to it when opened
			if ( linkTarget ) {
				linkTarget = linkTarget.slice( 1 );
				const targetEl = document.getElementById( linkTarget );
				targetEl.scrollIntoView( {behavior: 'smooth'} );
			}

			openStoriesModal( i );
		} );
	} );

	// Close Modal
	$( document ).keyup( function ( e ) {
		if ( 27 === e.keyCode ) { // 27 is the keycode for the escape key
			closeStoriesModal();
		}
	} );

	storyModal.find( '.close' ).on( 'click', function () {
		closeStoriesModal();
	} );

	$( document ).mouseup( function ( e ) {
		var container = storyModal;

		// if the target of the click isn't the container nor a descendant of the container
		if ( !container.is( e.target ) && 0 === container.has( e.target ).length ) {
			closeStoriesModal();
		}
	} );

	// Slider Information
	const info = slider.getInfo();
	const indexOfStories = info.slideCount;
	const paginationCounterTotal = storyModal.find( '.pagination__counter .total' );

	paginationCounterTotal.text( indexOfStories );

	currentStoryIndex();
	slider.events.on( 'indexChanged', currentStoryIndex );
}

// @since 2.2 Add active class when modal open
function openStoriesModal( i ) {
	var contentContain = document.body.querySelector( '.spirit-shell__site-contain' );

	if ( contentContain ) {
		contentContain.classList.add( '-bsd-stories-modal-active' );
	}

	storyModal.fadeIn( 400 );

	// When story's modal is open, go to the tile's index that was clicked
	slider.goTo( i );
	document.body.classList.add( '-jdrf-no-scroll' );
}

// @since 2.2 Remove active class when modal closes
function closeStoriesModal() {
	storyModal.fadeOut();

	var contentContain = document.body.querySelector( '.spirit-shell__site-contain' );

	if ( contentContain ) {
		contentContain.classList.remove( '-bsd-stories-modal-active' );
	}

	document.body.classList.remove( '-jdrf-no-scroll' );
}

function currentStoryIndex() {
	const info = slider.getInfo();
	const indexCurrent = info.index; // Starts count at 0
	const currentSlide = parseInt( indexCurrent + 1 );
	const paginationCounterCurrent = $( '.bsd-stories-modal-footer .pagination__counter .current' );

	paginationCounterCurrent.text( currentSlide );
}
